import type { UserFromDb, Client, Indexed } from "shared"
import { CardView, CenteredStatus } from "shared"
import { useHistory } from "react-router-dom"
import { X } from "lucide-react"
import "./UserInfoView.css"
import { ExistingUserInfo } from "./ExistingUserInfo"
import { NewUserInfo } from "./NewUserInfo"
import { UserBadge } from "../components/UserBadge"

export function UserInfoView({
	users,
	clientId,
	client,
	user,
	setUserData,
	newUserMode,
	onUserDeleted,
}: {
	users: Indexed<UserFromDb>
	clientId: string
	client: Client
	user: UserFromDb | null
	setUserData: (newData: UserFromDb) => void
	newUserMode: boolean
	onUserDeleted?: (userId: string) => void
}): JSX.Element {
	const history = useHistory()

	return user === undefined && !newUserMode ? (
		<CenteredStatus isLoading={true} />
	) : (
		<CardView className="user-info-view-card">
			<div className="user-info-title-row">
				<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
					<h2 className="bs-h2" style={{ margin: 0 }}>
						{newUserMode ? "Add New Users" : user?.name}
					</h2>
					<UserBadge user={user ?? undefined} showSso />
				</div>
				<X
					size={30}
					className="clickable"
					onClick={() => {
						history.replace({
							search: "",
						})
					}}
				/>
			</div>
			<div className="user-info-view-inner">
				{newUserMode ? (
					<NewUserInfo users={users} clientId={clientId} client={client} setUserData={setUserData}></NewUserInfo>
				) : (
					<ExistingUserInfo user={user} setUserData={setUserData} clientId={clientId} onUserDeleted={onUserDeleted} />
				)}
			</div>
		</CardView>
	)
}
